import {
    FOLIO_LIST_KARVY, GET_REGISTERED_BANKS, ORDER_GENERATION, PAYMENT_REQUEST,
    GET_PG_RESPONSE, VALIDATE_BROKER_CODE, FOLIO_BROKER_LIST, UPDATE_FOLIO_BROKER_LIST,
    BUCKET_ID, DIT_URL_DETAILS, SELECTED_OPTION, RESET_SELECTED_FUND, UPDATE_URL_DETAILS_FOR_QUICK_INVEST, UPDATE_CART_ITEM_BY_SCHEME_CODE, UPDATE_CART_ORDER_REVIEW_ITEM_BY_SCHEME_CODE
} from "../types/quickbuy";

export const folioList = (payload) => ({
    type: FOLIO_LIST_KARVY,
    payload
})
export const registerBank = (payload) => ({
    type: GET_REGISTERED_BANKS,
    payload
})
export const orderGenaration = (payload) => ({
    type: ORDER_GENERATION,
    payload
})
export const paymentRequest = (payload) => ({
    type: PAYMENT_REQUEST,
    payload
})
export const paymentResponse = (payload) => ({
    type: GET_PG_RESPONSE,
    payload
})
export const validateBroker = (payload) => ({
    type: VALIDATE_BROKER_CODE,
    payload
})
export const folioBrokerList = (payload) => ({
    type: FOLIO_BROKER_LIST,
    payload
})
export const updateFolioBrokerList = (payload) => ({
    type: UPDATE_FOLIO_BROKER_LIST,
    payload
})

export const bucketID = (payload) => ({
    type: BUCKET_ID,
    payload
})

export const ditURLDetails = (payload) => ({
    type: DIT_URL_DETAILS,
    payload
})

export const selectedOption = (payload) => ({
    type: SELECTED_OPTION,
    payload
})

export const resetSelectedFund = () => ({
    type: RESET_SELECTED_FUND
})

export const updateUrlDetailsForQuickInvest = (payload) => ({
    type: UPDATE_URL_DETAILS_FOR_QUICK_INVEST,
    payload
})

export const updateCartItemBySchemeCode = (payload) => ({
    type: UPDATE_CART_ITEM_BY_SCHEME_CODE,
    payload
})

export const updateCartOrderReviewItemBySchemeCode = (payload) => ({
    type: UPDATE_CART_ORDER_REVIEW_ITEM_BY_SCHEME_CODE,
    payload
})